import { DashboardTableWidget } from '../components/DashboardTableWidget';
import type { DashboardWidgetRendererProps } from './widgetRenderers.types';

export function TableRenderer({ widget, query, range }: DashboardWidgetRendererProps) {
  return (
    <DashboardTableWidget
      widget={widget}
      overview={query?.data}
      loading={Boolean(query?.isLoading)}
      error={Boolean(query?.isError)}
      range={range}
    />
  );
}
